import featherIcons from 'feather-icons';

// Stabilní inline-SVG ikona. Na rozdíl od globálního feather.replace() (které
// mutuje React-spravované <i> uzly a v překreslovaných seznamech/tabulkách
// způsobuje reflow „flash" - hlavička se na okamžik zobrazí pod řádky) je SVG
// vlastněné Reactem → žádný post-render zásah do DOM, žádný flash.
export function Icon({ name, size = 16, color, style }: {
  name: string; size?: number; color?: string; style?: React.CSSProperties;
}) {
  const def = (featherIcons.icons as Record<string, { toSvg: (o?: Record<string, unknown>) => string } | undefined>)[name];
  const html = def ? def.toSvg({ width: size, height: size }) : '';
  return (
    <span
      className="feather-icon"
      style={{ lineHeight: 0, display: 'inline-flex', color, ...style }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
